import { render, staticRenderFns } from "./Inscriptions-doglist-comp.vue?vue&type=template&id=25c1f7fe&scoped=true&"
import script from "./Inscriptions-doglist-comp.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-doglist-comp.vue?vue&type=script&lang=js&"
import style0 from "./Inscriptions-doglist-comp.vue?vue&type=style&index=0&id=25c1f7fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c1f7fe",
  null
  
)

export default component.exports